export default __webpack_public_path__ + "static/media/video.94fee97d.mp4";